import React from 'react';

const AuthContext = React.createContext(null);

const useAuth = () => React.useContext(AuthContext);

export { AuthContext, useAuth };